import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";

import { useEarningsQuantities } from "../useEarningsQuantities";
import { requestPayEarnings } from "./payEarnings.request";

export const usePayEarnings = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  const { refetch: refetchEarningsQuantities } = useEarningsQuantities({
    enabled: false
  });
  const refetchMobileMoneyBalance = useRefetchQuery(["mobile-money-balance"]);

  return useMutation({
    mutationFn: requestPayEarnings,
    ...options,
    onSuccess: (data, variables, context) => {
      refetchEarningsQuantities();
      refetchMobileMoneyBalance();
      options?.onSuccess?.(data, variables, context);
    }
  });
};

export default usePayEarnings;
